import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import './Sidebar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import * as ConfigTypes from 'config/ConfigTypes';
import { CSSTransition } from 'react-transition-group';
import Spinner from 'layouts/UIElements/Spinner/Spinner';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlidePos: 0,
            scrolling: 0,
            boxStyle: {
                transform: `translateY(0px)`
            }
        }
    }

    isLastClip = () => {
        let slideLength = (Math.ceil((this.props.slideItems) / ConfigTypes.SIDEBAR_ITEMS) - 1) * ConfigTypes.SIDEBAR_HEIGHT;
        if (parseInt(this.state.scrolling) <= -slideLength) return true;
        return false;
    }

    isFirstClip = () => {
        if (parseInt(this.state.scrolling) === 0) return true;
        return false;
    }

    getBottomClasses = () => {
        if (this.isLastClip()) return "custom-sidebar-bottom custom-disabled";
        return "custom-sidebar-bottom"
    }

    getTopClasses = () => {
        if (this.isFirstClip()) return "custom-sidebar-top custom-disabled";
        return "custom-sidebar-top"
    }

    updateStoreData = ({ currentSlidePos }) => {
        if (this.props.updateObjects && this.props.mainObj) {
            let currentSlideItem = (currentSlidePos + 1) * ConfigTypes.SIDEBAR_ITEMS;
            let showItems = this.props.mainObj.clipLength - ConfigTypes.SIDEBAR_ITEMS;

            if (currentSlideItem >= showItems) {
                let mediaOffset = this.props.mainObj.mediaOffset + ConfigTypes.CLIPS_LIMIT;
                if (mediaOffset < this.props.mainObj.mediaCount)
                    this.props.updateObjects({
                        ...this.props.mainObj,
                        currentSlidePos,
                        mediaOffset: mediaOffset,
                        mediaNext: true
                    });
            } else {
                this.props.updateObjects({
                    ...this.props.mainObj,
                    currentSlidePos,
                    currentSlideItem
                });
            }
        }
    }

    refreshSlideObj = ({ currentSlidePos, scrolling }) => {
        this.setState({
            currentSlidePos, show: true, scrolling,
            boxStyle: { transform: `translateY(${scrolling}px)` }
        });
        this.updateStoreData({ currentSlidePos });
    }

    setSvgAttributes = () => {
        ConfigTypes.SIDEBAR_SVG_ITEMS.forEach(item => {
            let itemEl = document.getElementById(item.id);
            if (itemEl && item.data && item.data.length) {
                itemEl.removeAttribute("aria-hidden");
                item.data.forEach(entry => {
                    itemEl.setAttribute(entry.name, entry.value);
                })
            }
        })
    }

    onKeyUpChevUp = (e) => {
        if (e.key === ConfigTypes.ENTER) {
            if (!this.isFirstClip()) {
                this.onChevTopClick();
            }
        }
    }

    onKeyUpChevBottom = (e) => {
        if (e.key === ConfigTypes.ENTER) {
            if (!this.isLastClip()) {
                this.onChevBottomClick();
            }
        }
    }

    onChevBottomClick = () => {
        let currentSlidePos = this.state.currentSlidePos + ConfigTypes.SIDEBAR_NEXT;
        let scrolling = -(currentSlidePos * ConfigTypes.SIDEBAR_HEIGHT);
        this.refreshSlideObj({ scrolling, currentSlidePos });
    }

    onChevTopClick = () => {
        let currentSlidePos = this.state.currentSlidePos - ConfigTypes.SIDEBAR_NEXT;
        let scrolling = this.state.scrolling + ConfigTypes.SIDEBAR_HEIGHT;
        this.refreshSlideObj({ scrolling, currentSlidePos });
    }

    showClips = () => {
        let lounge = process.env.REACT_APP_LOUNGE || '';
        return (
            <div className="custom-sidebar">
                <div className={this.getTopClasses()} tabIndex="0"
                    role="button" aria-label={`"Move top the list of ${lounge} clips"`}
                    onKeyUp={this.onKeyUpChevUp}
                    onClick={!this.isFirstClip() ? this.onChevTopClick : null}>
                    <FontAwesomeIcon icon={faChevronUp} id="sidebar_chevTop_icon" />
                </div>
                <div className="custom-sidebar-content">
                    <div className="custom-sidebar-box" style={this.state.boxStyle}>
                        <CSSTransition in={this.state.show} timeout={200}>
                            {this.props.children}
                        </CSSTransition>
                    </div>
                </div>
                <div className={this.getBottomClasses()} tabIndex="0"
                    role="button" aria-label={`"Move bottom the list of ${lounge} clips"`}
                    onKeyUp={this.onKeyUpChevBottom}
                    onClick={!this.isLastClip() ? this.onChevBottomClick : null}>
                    <FontAwesomeIcon icon={faChevronDown} id="sidebar_chevBottom_icon" />
                </div>
            </div>)

    }

    componentDidMount() {
        if (this.props.currentSlidePos) {
            this.setState({ currentSlidePos: this.props.currentSlidePos });
        }
        this.setSvgAttributes();
    }

    componentWillUnmount() {
        this.props.updateMediaObjects({ currentSlidePos: null });
    }

    render() {
        return (
            <div className="Sidebar">
                {this.showClips()}
                {this.props.mediaObjects.loading && <div className="sidebar-overlay"><Spinner /></div>}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj))
})

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);